<div class="space-y-8">
  <!-- Refund & Return Modals -->
  <app-refund-modal
    *ngIf="selectedTransaction"
    [show]="showRefundModal"
    [transaction]="selectedTransaction"
    [loading]="isRefunding"
    (close)="showRefundModal = false"
    (confirmRefund)="handleRefund($event)"
  >
  </app-refund-modal>

  <app-return-modal
    *ngIf="selectedTransaction"
    [show]="showReturnModal"
    [transaction]="selectedTransaction"
    (close)="showReturnModal = false"
    (confirmRefund)="handleReturn($event)"
  >
  </app-return-modal>

  <!-- Header -->
  <div class="sm:flex sm:items-center sm:justify-between">
    <h1 class="text-2xl font-semibold text-gray-900">Transactions</h1>
    <button
      *ngIf="isRefundsManager"
      (click)="openTransferModal()"
      class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
      Create Refund
    </button>
  </div>

  <!-- Filters -->
  <div
    class="flex flex-wrap gap-4 items-center bg-gray-50 p-4 rounded-lg border border-gray-200"
  >
    <select
      [(ngModel)]="transactionType"
      (change)="onSelectionChange()"
      class="w-48 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-xs"
    >
      <option value="" selected>-- Type --</option>
      <option value="BANK_TRANSFER">BANK_TRANSFER</option>
      <option value="P2P_TRANSFER">P2P_TRANSFER</option>
      <option value="CRYPTO_PAYMENT">CRYPTO_PAYMENT</option>
      <option value="CARD_FUNDING">CARD_FUNDING</option>
      <option value="OPENING_FEE">OPENING_FEE</option>
      <option value="MONTHLY_SUBSCRIPTION">MONTHLY_SUBSCRIPTION</option>
      <option value="CARD_PAYMENT_FEE">CARD_PAYMENT_FEE</option>
      <option value="NEW_VIRTUAL_CARD_FEE">NEW_VIRTUAL_CARD_FEE</option>
      <option value="REMITTANCE">REMITTANCE</option>
      <option value="TOPUP">TOPUP</option>
      <option value="DEBT_RECOVERY">DEBT_RECOVERY</option>
      <option value="BALANCE_MIGRATION">BALANCE_MIGRATION</option>
      <option value="CARD_WITHDRAWAL">CARD_WITHDRAWAL</option>
      <option value="REFUND">REFUND</option>
      <option value="RETURN">RETURN</option>
    </select>

    <select
      [(ngModel)]="transactionStatus"
      (change)="onSelectionChange()"
      class="w-48 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-xs"
    >
      <option value="" selected>-- Status --</option>
      <option value="NOT_STARTED">NOT_STARTED</option>
      <option value="PROCESSING">PROCESSING</option>
      <option value="FAILED">FAILED</option>
      <option value="SUCCEEDED">SUCCEEDED</option>
      <option value="RETURNED">RETURNED</option>
      <option value="REFUNDED">REFUNDED</option>
    </select>

    <select
      [(ngModel)]="accountingType"
      (change)="onSelectionChange()"
      class="w-48 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-xs"
    >
      <option value="" selected>-- Accounting Type --</option>
      <option value="CREDIT">CREDIT</option>
      <option value="DEBIT">DEBIT</option>
    </select>

    <select
      [(ngModel)]="paymentMethod"
      (change)="onSelectionChange()"
      class="w-48 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-xs"
    >
      <option value="" selected>-- Payment Method --</option>
      <option value="ACH">ACH</option>
      <option value="SEPA">SEPA</option>
      <option value="SOLANA">SOLANA</option>
      <option value="FED_WIRE">FED_WIRE</option>
      <option value="FED_NOW">FED_NOW</option>
    </select>

    <label
      class="inline-flex items-center gap-2 px-3 py-2 rounded-md border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 text-xs font-medium cursor-pointer select-none transition"
    >
      <input
        type="checkbox"
        [(ngModel)]="activeRfi"
        (change)="onActiveRfiChange()"
        class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 cursor-pointer"
      />
      <span>Active RFI only</span>
    </label>

    <button
      (click)="clearForm()"
      class="ml-auto px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-xs font-medium transition"
    >
      Clear
    </button>
  </div>

  <!-- Table -->
  <div class="overflow-x-auto bg-white shadow rounded-lg">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-700">
            User
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-700">
            Amount
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-700">
            Fees
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-700">
            Type
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-700">
            Status
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-700">
            Accounting
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-700">
            Details
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-700">
            Actions
          </th>
        </tr>
      </thead>

      <tbody class="divide-y divide-gray-100">
        <tr *ngFor="let transaction of transactions">
          <td class="px-2 py-1 text-xs text-gray-900">
            <div>
              {{ transaction?.user?.first_name }}
              {{ transaction?.user?.last_name }}
              <div class="text-xs text-gray-500">
                {{ transaction?.user?.email }}
              </div>
            </div>
          </td>
          <td class="px-4 py-2 text-xs text-gray-900">
            <ng-container
              *ngIf="
                transaction.transaction_type === 'BALANCE_CONVERSION' &&
                  getEntry(transaction, 'DEBIT') as debit;
                else singleAmount
              "
            >
              {{ debit.amount }} {{ debit.currency }}
              <ng-container *ngIf="getEntry(transaction, 'CREDIT') as credit">
                → {{ credit.amount }} {{ credit.currency }}
              </ng-container>
            </ng-container>
            <ng-template #singleAmount>
              {{ transaction.amount }} {{ transaction.amount_currency }}
            </ng-template>
            <br />
            <span class="text-nowrap" *ngIf="transaction.equivalent_in_euros"
              >(€ {{ transaction.equivalent_in_euros }})</span
            >
          </td>
          <td class="px-4 py-2 text-xs text-gray-900">
            {{ transaction.fees }} {{ transaction.fees_currency }}
          </td>
          <td class="px-4 py-2 text-xs text-gray-900">
            {{ transaction.transaction_type }}
          </td>
          <td class="px-4 py-2 text-xs">
            <div class="flex flex-col items-start gap-1.5">
              <span
                [ngClass]="{
                  'bg-green-500': transaction.status === 'SUCCEEDED',
                  'bg-red-500': transaction.status === 'FAILED',
                  'bg-cyan-500': transaction.status === 'NOT_STARTED',
                  'bg-yellow-500': transaction.status === 'REVIEW',
                  'bg-blue-500': transaction.status === 'PROCESSING',
                  'bg-red-600': transaction.status === 'RETURNED',
                  'bg-purple-500': transaction.status === 'REFUNDED',
                }"
                class="inline-block px-2 py-1 text-white text-xs font-semibold rounded-full"
              >
                {{ transaction.status }}
              </span>
              <span
                *ngIf="isWaitingForRfi(transaction)"
                [attr.title]="
                  'Requested on: ' +
                  (transaction.rfi_received_at | date: 'dd/MM/yyyy HH:mm')
                "
                class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-300 shadow-sm cursor-help hover:bg-amber-200 transition-colors whitespace-nowrap"
              >
                <svg
                  class="w-3.5 h-3.5 text-amber-600 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
                <span>Awaiting RFI</span>
              </span>
            </div>
          </td>
          <td class="px-4 py-2 text-xs">
            <span
              [ngClass]="{
                'bg-green-500': transaction.accounting_type == 'CREDIT',
                'bg-red-500': transaction.accounting_type == 'DEBIT',
              }"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-white"
            >
              {{ transaction.accounting_type }}
            </span>
          </td>
          <td class="px-4 py-2 text-xs text-gray-500">
            <div>{{ transaction.created_at | date: "dd/MM/yyyy HH:mm" }}</div>
            <div *ngIf="transaction.uuid">
              Moneco ID: {{ transaction.uuid }}
            </div>
            <div *ngIf="transaction.noah_id">
              Noah ID: {{ transaction.noah_id }}
            </div>
            <div *ngIf="transaction?.beneficiary?.name">
              Name: {{ transaction.beneficiary.name }}
            </div>
            <div *ngIf="transaction?.beneficiary?.iban">
              IBAN: {{ transaction.beneficiary.iban }}
            </div>
            <div *ngIf="transaction.payment_method">
              Type: {{ transaction.payment_method }}
            </div>
            <div *ngIf="transaction.beneficiary.note">
              Note: {{ transaction.beneficiary.note }}
            </div>
            <div *ngIf="transaction.beneficiary.revolupay">
              Code RevoluPay: {{ transaction.beneficiary.revolupay }}
            </div>
            <div *ngIf="transaction.beneficiary.revolupay_id">
              RevoluPay Transaction ID:
              {{ transaction.beneficiary.revolupay_id }}
            </div>
            <div
              *ngIf="
                transaction.tx_hash &&
                transaction.transaction_type === 'CRYPTO_PAYMENT'
              "
            >
              TX Hash:
              <a
                [href]="'https://solscan.io/tx/' + transaction.tx_hash"
                target="_blank"
                rel="noopener noreferrer"
                class="text-indigo-500 hover:text-indigo-700 underline"
                title="{{ transaction.tx_hash }}"
                >{{ truncateHash(transaction.tx_hash) }}</a
              >
            </div>
          </td>
          <td class="px-4 py-2 text-xs">
            <div class="flex flex-col gap-2">
              <button
                *ngIf="
                  !transaction.refunded_at &&
                  isComplianceAdmin &&
                  [
                    'TOPUP',
                    'BANK_TRANSFER',
                    'CARD_FUNDING',
                    'REMITTANCE',
                    'OPENING_FEE',
                    'MONTHLY_SUBSCRIPTION',
                    'NEW_VIRTUAL_CARD_FEE',
                    'DEBT_RECOVERY',
                    'BALANCE_CONVERSION',
                  ].includes(transaction.transaction_type)
                "
                (click)="openRefundModal(transaction)"
                class="inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium rounded-md text-white bg-red-600 hover:bg-red-700"
              >
                Refund
              </button>
              <!-- Visible only on Credit bank transfer and Credit Crypto deposit -->
              <button
                *ngIf="canReturnTransaction(transaction)"
                (click)="openReturnModal(transaction)"
                class="inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700 cursor-pointer"
              >
                Return
              </button>
              <span
                *ngIf="transaction.refunded_at"
                class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-600/20"
              >
                Refunded
              </span>
              <span
                *ngIf="transaction.returned_at"
                class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-600/20"
              >
                Returned
              </span>
            </div>
          </td>
        </tr>

        <!-- Loading / Empty -->
        <tr *ngIf="submitted || transactions.length === 0">
          <td colspan="9" class="py-6 text-center text-xs text-gray-500">
            <ng-container *ngIf="submitted; else empty">
              <div class="flex justify-center items-center gap-2">
                <div
                  class="w-5 h-5 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"
                ></div>
                <span>Loading data...</span>
              </div>
            </ng-container>
            <ng-template #empty
              >Sorry, we couldn't find any results.</ng-template
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="flex justify-center">
    <nav class="inline-flex rounded-md shadow-sm">
      <button
        (click)="goToPreviousPage()"
        [disabled]="!previousPageUrl"
        class="px-3 py-2 border border-gray-300 bg-white text-xs rounded-l-md hover:bg-gray-50 disabled:opacity-50"
      >
        ‹
      </button>
      <button
        *ngFor="let page of pageNumbers"
        (click)="page !== '...' && loadTransactions(page)"
        [disabled]="page === '...' || currentPage === page"
        [ngClass]="{
          'bg-indigo-500 text-white font-semibold': currentPage === page,
          'bg-white text-gray-700': currentPage !== page && page !== '...',
        }"
        class="px-4 py-2 border border-gray-300 text-xs"
      >
        {{ page }}
      </button>
      <button
        (click)="goToNextPage()"
        [disabled]="!nextPageUrl"
        class="px-3 py-2 border border-gray-300 bg-white text-xs rounded-r-md hover:bg-gray-50 disabled:opacity-50"
      >
        ›
      </button>
    </nav>
  </div>

  <!-- Create Refund Modal -->
  <div
    *ngIf="showTransferModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm"
  >
    <div
      class="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl border border-gray-200"
    >
      <h2 class="text-xl font-semibold text-gray-900 mb-4">Create Refund</h2>

      <!-- Info -->
      <div class="mb-5 bg-gray-50 p-4 rounded-lg text-sm text-gray-800 border">
        <p>Transfer funds to this user from a Moneco wallet.</p>
      </div>

      <!-- Source Wallet Select -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1"
          >Source Wallet</label
        >
        <select
          [(ngModel)]="transferSourceWallet"
          class="w-full border border-gray-300 px-3 py-2 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
        >
          <option value="" disabled>Select source wallet</option>
          <option value="YIELD">YIELD</option>
          <option value="OPENING_FEES">OPENING_FEES</option>
          <option value="MARKETING">MARKETING</option>
          <option value="KKIAPAY">KKIAPAY</option>
          <option value="YELLOWCARD">YELLOWCARD</option>
          <option value="USDT_WALLET">USDT_WALLET</option>
          <option value="SEPA_WALLET">SEPA</option>
          <option value="USDC_REFUND_WALLET">USDC_REFUND_WALLET</option>
        </select>
      </div>

      <!-- Amount Input -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1"
          >Amount</label
        >
        <input
          type="number"
          [(ngModel)]="transferAmount"
          placeholder="Enter amount"
          class="w-full border border-gray-300 px-3 py-2 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
        />
      </div>

      <!-- Reference Input -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1"
          >Reference</label
        >
        <input
          type="text"
          [(ngModel)]="transferReference"
          placeholder="Enter reference"
          class="w-full border border-gray-300 px-3 py-2 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
        />
      </div>

      <!-- Related Transaction UUID Input (Optional) -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1"
          >Related Transaction
          <span class="text-gray-400">(Optional)</span></label
        >
        <input
          type="text"
          [(ngModel)]="relatedTransactionUuid"
          placeholder="Enter transaction ID"
          class="w-full border border-gray-300 px-3 py-2 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
        />
      </div>

      <!-- Related Transaction Type Select (Required if UUID is provided) -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1"
          >Related Transaction Type
          <span *ngIf="relatedTransactionUuid" class="text-red-500">*</span>
          <span *ngIf="!relatedTransactionUuid" class="text-gray-400"
            >(Optional)</span
          ></label
        >
        <select
          [(ngModel)]="relatedTransactionType"
          class="w-full border border-gray-300 px-3 py-2 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
          [class.border-red-300]="
            relatedTransactionUuid && !relatedTransactionType
          "
        >
          <option value="">Select type</option>
          <option value="OPENING_FEE">OPENING_FEE</option>
        </select>
        <p
          *ngIf="relatedTransactionUuid && !relatedTransactionType"
          class="mt-1 text-xs text-red-500"
        >
          Required when Related Transaction UUID is provided
        </p>
      </div>

      <!-- Actions -->
      <div class="flex justify-end space-x-2 pt-2">
        <button
          type="button"
          (click)="closeTransferModal()"
          class="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-200"
        >
          Cancel
        </button>
        <button
          type="button"
          (click)="confirmTransfer()"
          [disabled]="
            isTransferring ||
            !transferSourceWallet ||
            transferAmount === null ||
            !transferReference
          "
          class="bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-indigo-700 disabled:opacity-50"
        >
          <ng-container *ngIf="!isTransferring; else transferring">
            Transfer Funds
          </ng-container>
          <ng-template #transferring>Transferring...</ng-template>
        </button>
      </div>
    </div>
  </div>
</div>
